<template>
    <BModal :model-value="modal" scrollable centered title="Maintenance Issue" hide-footer @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Maintenance Issue</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <div class="form-group">
                <BFormInput type="text" v-model="maintenanceIssueForm.name" placeholder="Name"></BFormInput>
            </div>
            <div class="form-group">
                <BFormTextarea type="text" v-model="maintenanceIssueForm.description" placeholder="Description"></BFormTextarea>
            </div>
        </BForm>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{ maintenanceIssueData && maintenanceIssueData.uuid ? 'Update' : 'Save'}}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template> 
    </BModal>
</template>

<script>
import { BModal, BFormInput,BButton, BForm, BFormTextarea } from 'bootstrap-vue-next';
import { ref, inject, watch } from 'vue';

export default {
    components: {
        BModal,
        BFormInput,
        BButton,
        BForm,
        BFormTextarea
    },
    props: {
        modal: Boolean,
        maintenanceIssueData: Object,
    },
    emits: ["update:modal"],
    setup(props, { emit }) {
        const repositories = inject('repositories');
        const maintenanceIssueRepository = repositories ? repositories.maintenanceIssue : null;

        const maintenanceIssueForm = ref({
            name: '',
            description: ''
        });

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        }

        const handleAction =  () => {
            props.maintenanceIssueData.uuid ? update() : create()
        }

        const create = async () => {
            await maintenanceIssueRepository.create(maintenanceIssueForm.value).then(() => {
                updateModal(false)
                maintenanceIssueForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        const update = async () => {
            await maintenanceIssueRepository.update(maintenanceIssueForm.value, props.maintenanceIssueData.uuid).then(() => {
                updateModal(false)
                maintenanceIssueForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        watch(() => props.maintenanceIssueData, (newData) => {
            if (newData) {
                maintenanceIssueForm.value = { ...newData };
            }
        }, { immediate: true });

        return {
            maintenanceIssueForm,
            updateModal,
            handleAction,
            create,
            update
        }
    }
}
</script>


